import { AwsUi } from '../../../../core/runtime/src';
import { unsafelyCreateElementFromString } from '../../../../core/runtime/src/mithril';
import { Icon } from '../../../icon/src';
export function ResizeHandle() {
    return (AwsUi.__createElement("div", { className: "awsui-app-layout__resize-handle" },
        AwsUi.__createElement("svg", { focusable: false, xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" },
            AwsUi.__createElement("line", { "stroke-width": "2", x1: "2", y1: "5", x2: "14", y2: "5" }),
            AwsUi.__createElement("line", { "stroke-width": "2", x1: "14", y1: "10", x2: "2", y2: "10" }))));
}
export function DrawerButton(_a) {
    var className = _a.className, drawer = _a.drawer, onToggle = _a.onToggle;
    var _b, _c;
    return (AwsUi.__createElement("button", { className: className, "aria-label": (_c = (_b = drawer.ariaLabels) === null || _b === void 0 ? void 0 : _b.triggerButton, (_c !== null && _c !== void 0 ? _c : '')), type: "button", onclick: function () { return onToggle(drawer.id); } },
        drawer.trigger.iconName ? AwsUi.__createElement(Icon, { name: drawer.trigger.iconName }) : null,
        drawer.trigger.iconSvg ? (AwsUi.__createElement("span", { className: "awsui-app-layout__drawer-icon" }, unsafelyCreateElementFromString(drawer.trigger.iconSvg))) : null));
}
//# sourceMappingURL=primitives.js.map